import { Link } from 'react-router-dom';

import SegmentedBar from '../../../common/components/segmented-bar/segmented-bar';
import StatusPill from '../../../common/components/status-pill/status-pill';
import { PHASE_LABEL, PROJECT_STATE_LABEL, PROJECT_STATE_TONE } from '../../../core/constants/domain';
import { ROUTES } from '../../../core/constants/routes';
import { useTasksList } from '../../../global/contexts/work/work';
import { summarizeProgress } from '../utils/progress';

import '../styles/project-card.css';

export default function ProjectCard({ project }) {
    const { data, isPending } = useTasksList({ projectId: project.id });
    const progress = summarizeProgress(data?.items ?? []);

    return (
        <li className="project-card">
            <Link to={ROUTES.PROJECT(project.id)} className="project-card__link">
                <span className="project-card__top">
                    <StatusPill tone={PROJECT_STATE_TONE[project.state]}>
                        {PROJECT_STATE_LABEL[project.state] ?? project.state}
                    </StatusPill>
                    <span className="project-card__phase">{PHASE_LABEL[project.bootstrapPhase] ?? ''}</span>
                </span>
                <span className="project-card__name">{project.name}</span>
                <span className="project-card__description">{project.description}</span>
                <span className="project-card__progress">
                    <span className="project-card__percent">
                        {isPending ? '—' : `${progress.percent}%`}
                    </span>
                    <span className="project-card__counts">
                        {isPending ? 'Calculando avance…' : `${progress.done} de ${progress.total} tareas hechas`}
                    </span>
                </span>
                <SegmentedBar segments={progress.segments} label={`Avance de ${project.name}`} />
            </Link>
        </li>
    );
}
